<template>
  <v-container>
    <v-row justify="space-between" align="center" class="header-area">
      <h2>Employee Dashboard</h2>
      <div class="d-flex align-center">
        <v-btn class="mr-2" outlined color="primary" @click="triggerFileInput">
          <v-icon left>mdi-upload</v-icon>
          Upload Excel
        </v-btn>
        <input type="file" ref="fileInput" accept=".xlsx,.xls" style="display: none" @change="handleFileUpload"
          multiple />
        <v-btn class="mr-4" outlined color="success" @click="handleDownload">
          <v-icon left>mdi-download</v-icon>Download Sample</v-btn>
      </div>
    </v-row>

    <!-- <div v-if="files.length > 0" class="file-list">
      <v-row>
        <v-col v-for="(file, index) in files" :key="index" cols="12" sm="6" md="4">
          <v-card class="file-card">
            <v-card-title>{{ file.name }}</v-card-title>

            <v-btn icon @click="removeFile(index)" class="close-btn" color="red">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </div> -->
    <!-- 
    {{ hasInvalidFile }}
    {{ files.length }} -->
    <div v-if="parsedData.length" class="file-list">
      <v-row>
        <v-col v-for="(file, index) in files" :key="index" cols="12" sm="6" md="4">
          <v-card class="file-card position-relative pa-3 d-flex align-center">
            <v-btn icon @click="removeFile(index)" class="close-btn" color="red" size="x-small">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-card-title class="text-subtitle-1 flex-shrink-0">{{
              file.name
            }}</v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div style="position: absolute; right: 40px;margin-top: -25px;">
             <v-btn v-if="files.length > 0 && !hasInvalidFile" color="primary" @click="uploadFile" class="mt-4 align-center">
      Submit
    </v-btn>
    </div>
    <!-- {{ parsedData}} -->
    <div v-if="parsedData.length && showTable" class="table-container">

      <table class="styled-table">
        <thead>
          <tr>
            <th style="color:#737373" v-for="header in headers" :key="header">{{ header.text }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rowIndex) in parsedData.slice(0)" :key="rowIndex">
            <td v-for="(cell, cellIndex) in row" :key="cellIndex" :class="cellIndex === 'Name' || cellIndex === 'Address' || cellIndex === 'Birth Date' || cellIndex === 'Designation' || cellIndex === 'Card Valid Date'  ? 'td-min-width' : ''">
              {{ cell }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
   
  </v-container>
</template>


<script setup>
import { ref, watch } from "vue";
import { computed } from "vue";

import * as XLSX from "xlsx";
import { EmployeeFileUpload } from "@/services/apiServices";
import Swal from "sweetalert2";

import { useTheme } from '@/composables/useThemes'
const { isDarkTheme } = useTheme()


const fileInput = ref(null);
const files = ref([]);
// console.log("Files ", files.value);
const showTable = computed(() => parsedData.value.length > 0);
const parsedData = ref([]);
const headers = ref([]);
// console.log(" Headers ", headers.value);
const hasInvalidFile = ref(false);

// Trigger the file input click
const triggerFileInput = () => {
  fileInput.value.click();
};

const handleFileUpload = (event) => {
  const newFiles = event.target.files || event.dataTransfer.files;
  if (newFiles.length > 0) {
    Array.from(newFiles).forEach((file) => {
      if (validateFileExtension(file)) {
        parseExcelFile(file); // Parse and validate the file before uploading
        // showTable.value = true;
      } else {
        alert("Invalid file format. Please upload .xlsx or .xls files.");
      }
    });
  }
};

// Validate file extension
const validateFileExtension = (file) => {
  const validExtensions = [".xlsx", ".xls"];
  const fileExtension = file.name.split(".").pop().toLowerCase();
  return validExtensions.includes(`.${fileExtension}`); // Check if the file extension is valid
};

// Validate headers and data
const validateHeadersAndData = (data, fileName) => {
  const headers = data[0];
  const requiredHeaders = [
    "Name",
    "Employee Id",
    "Blood Group",
    "Address",
    "Contact",
    "Birth Date",
    "Designation",
    "Citizenship No",
    "Pan No",
    // "Gender",
    // "Valid Date",
    // "Category",
    // "Appointment",
    // "Teaching Level",
  ];
  const missingHeaders = requiredHeaders.filter(
    (header) => !headers.includes(header)
  );
  if (missingHeaders.length > 0) {
    Swal.fire({
      icon: "error",
      title: "Upload failed!",
      html: `File: <strong>${fileName}</strong> has missing headers.<br>Missing headers: <strong>${missingHeaders.join(
        ", "
      )}</strong>`,
      confirmButtonColor: "#d33",
    });
    return false; // File is invalid due to missing headers
  }
  return true; // File is valid
};

// Parse the uploaded Excel file
const parseExcelFile = (file) => {
  hasInvalidFile.value = false;
  const reader = new FileReader();
  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: "array", dateNF: 'mm/dd/yyyy', cellDates: true, });
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];

    const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" });
    const jsonData = rawData
      .filter(row => row.some(cell => cell !== ""))
      .map(row => row.map(cell => {
        if (cell instanceof Date) {
          return cell.toLocaleDateString('en-US');
        }
        return cell;
      }));
    if (validateHeadersAndData(jsonData, file.name)) {
      // Add file if it doesn't already exist


      // Extract headers and parsed data
      headers.value = jsonData[0].map((header) => ({
        text: header,
        value: header,
      }));
      for (const row of jsonData.slice(1)) {
        const denseRow = [...row]; // Convert sparse → dense (empty → undefined)
        const hasEmpty = denseRow.some(cell => cell === undefined);
        if (row.length > 0) {
          const isColumnEmpty = denseRow[0] === undefined ||
            denseRow[0] === null ||
            denseRow[0] === '' ||
            (typeof denseRow[0] === 'string' && denseRow[0].trim() === '');

          // console.log('Is column 0 empty?', isColumnEmpty); // true
          // console.log('Row:', row.length); // true

        }

        if (hasEmpty) {
          hasInvalidFile.value = true;
          Swal.fire({
            icon: "error",
            title: "Upload failed!",
            text: "The file has empty cells.",
            confirmButtonColor: "#d33",
          });
          // console.log("hasEmpty:", hasEmpty);
          break;
        }
      }
      if (!hasInvalidFile.value) {
        if (!files.value.some((f) => f.name === file.name)) {
          files.value.push({ name: file.name, isValid: true, file });
        }
        parsedData.value.push(
          ...jsonData
            .slice(1)
            .map((row) =>
              row.reduce(
                (acc, col, i) => ({ ...acc, [headers.value[i].value]: col }),
                {}
              )
            )
        );
      } else {
        hasInvalidFile.value = true;
      }
    }
  };
  reader.readAsArrayBuffer(file);
};

const removeFile = (index) => {
  const removedFile = files.value.splice(index, 1)[0];
  // console.log("Removed file:", removedFile);

  // Reset parsed data and reprocess remaining files
  parsedData.value = [];
  files.value.forEach((f) => parseExcelFile(f.file));

  // Hide table if no files left
  if (!files.value.length) {
    headers.value = [];
    showTable.value = false;
  }
};

const uploadFile = async () => {
  const formData = new FormData();

  files.value.forEach((fileObj) => {
    formData.append("file", fileObj.file);
  });
  // console.log("Form data:", formData);
  try {
    const res = await EmployeeFileUpload(formData);
    if (res.status === 201) {
    setTimeout(() => {
      files.value = [];
      parsedData.value = [];
      headers.value = [];
    }, 1500);

    Swal.fire({
      icon: "success",
      title: "Employee uploaded successfully",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      background: isDarkTheme.value ? '#333' : '#fff',
      color: isDarkTheme.value ? '#fff' : '#000',
      iconColor: "#28a745",
    });
  }

  } catch (error) {
    console.error("Upload failed", error);
    alert("Upload failed. Please try again.");
  }
};

//   const removedFile = files.value[index];
// console.log("Removed file", removedFile);

// // Remove file using filter to ensure reactivity
// files.value = files.value.filter((_, i) => i !== index);
// console.log("Files after remove:", JSON.stringify(files.value));
// files.value = [...files.value];
// if (fileInput.value) {
//   console.log("File input", fileInput.value);
//   fileInput.value.value = "";
// }

// // Ensure unique files before parsing
// files.value = [...new Set(files.value)];

// // Debugging: Check for duplicates before parsing
// console.log("Before parsing:", JSON.stringify(files.value));
// parsedData.value.length = 0;
// files.value.forEach((fileObj) => {
//   if (fileObj.isValid) {
//     console.log("Parsing file:", fileObj.file.name);
//     parseExcelFile(fileObj.file);
//   }
// });

// console.log("After parsing:", JSON.stringify(files.value));

// // Reset table headers if no files remain
// if (files.value.length === 0) {
//   headers.value = [];
//   showTable.value = false;
// }

// };

const handleDownload = () => {
  const link = document.createElement("a");
  // link.href = `${window.location.origin}/src/assets/excel_templates/Employee_Sample_Meroprints.xlsx`;
  link.href = `${window.location.origin}/excel_templates/Employee_Sample_Meroprints.xlsx`;
  link.download = "Employee_Sample_Meroprints.xlsx";
  link.click();
};
</script>

<style scoped>
.td-min-width{
  min-width: 175px;
}
.table-container {
  margin-top: 20px;
  overflow-x: auto;
}

.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 0.9em;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  min-width: 400px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
}

.styled-table thead tr {
  background-color: #009879;
  color: #ffffff;
  text-align: left;
}

.styled-table th,
.styled-table td {
  padding: 12px 15px;
}

.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}

.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}

.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #009879;
}

.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #009879;
}


.file-card {
  background-color: #4fd1c5;
  position: relative;
  overflow: visible;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  width: 100%;
  max-width: 280px;
  margin: auto;
}

.file-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}


.close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  transform: translate(50%, -50%);
  width: 22px;
  height: 22px;
  min-width: 22px;
  padding: 0;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.close-btn:hover {
  background-color: #ff6b6b;
  transform: translate(50%, -50%) scale(1.1);
}

/* File Name Styling */
.v-card-title {
  font-size: 14px;
  font-weight: bold;
  color: #2c3e50;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  padding: 10px 0;
}


.file-card:hover .v-card-title {
  color: #f09999;
}
</style>
